var _style;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon91S195Px(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 295 426",
    height: "195px",
    width: "195px",
    style: {
      height: "100%",
      width: "100%",
      backgroundColor: "rgb(20, 57, 82)",
      shapeRendering: "auto"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      transformOrigin: "50% 50%",
      transform: "rotate(0deg) scale(0.8, 0.8)"
    },
    className: "ldl-scale"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transformOrigin: "147.5px 213px",
      transform: "rotateY(0deg)",
      animation: "coin-h-9c85b0b6-a20d-44d2-be04-5c50f3c4155a 9.090909090909092s linear 0s infinite normal forwards"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "hsla(240,8%,12%,1)",
    d: "M145 290.682C174.096 290.682 201.19 282.093 223.896 267.305C224.622 271.648 225 276.109 225 280.659C225 324.946 189.183 360.847 145 360.847C113.369 360.847 86.0252 342.446 73.0423 315.741H4.25232C19.91 379.063 76.9864 426 145 426C225.081 426 290 360.929 290 280.659C290 256.23 283.987 233.208 273.364 213C283.987 192.792 290 169.77 290 145.341C290 116.942 281.874 90.4451 267.825 68.0594C283.626 62.7016 295 47.7175 295 30.0706V5.01176H182.888C170.81 1.7435 158.108 0 145 0C64.9187 0 0 65.0715 0 145.341C0 225.611 64.9187 290.682 145 290.682ZM145 65.1529C100.817 65.1529 65 101.054 65 145.341C65 149.891 65.378 154.352 66.1043 158.695C69.9179 181.499 83.3337 201.041 102.042 213C114.452 220.933 129.19 225.529 145 225.529C160.81 225.529 175.548 220.933 187.958 213C206.666 201.041 220.082 181.499 223.896 158.695C224.622 154.352 225 149.891 225 145.341C225 101.054 189.183 65.1529 145 65.1529Z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }))))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "coin-h-9c85b0b6-a20d-44d2-be04-5c50f3c4155a",
    "data-anikit": "",
    parsed: "ok"
  }, "\n\t\t@keyframes coin-h-9c85b0b6-a20d-44d2-be04-5c50f3c4155a\n\t\t{\n\t\t0% {\n\t\tanimation-timing-function: cubic-bezier(0.5856,0.0703,0.4143,0.9297);\n\t\ttransform: rotateY(0deg);\n\t\t}\n\t\t100% {\n\t\ttransform: rotateY(3600deg);\n\t\t}\n\t\t}\n\t")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon91S195Px);
export default __webpack_public_path__ + "static/media/icon-9.1s-195px.406490d9885445c7bba3f2e90acfa74d.svg";
export { ForwardRef as ReactComponent };